import React from 'react';
import { useTranslation } from 'react-i18next';
const UPLOAD_ROW_STATUS = {
    UPLOADING: 'UPLOADING',
    COMPLETE: 'COMPLETE',
    FAILED: 'FAILED'
};
const UploadedFileRow = ({ fileName, status, percentage, etaLabel, errorMessage, onRemove }) => {
    const { t } = useTranslation();
    const isFailed = status === UPLOAD_ROW_STATUS.FAILED;
    const isComplete = status === UPLOAD_ROW_STATUS.COMPLETE;
    // Failed per the mockups: a full-width red bar with a "0%" label.
    const barColor = isFailed ? 'bg-red-600' : 'bg-emerald-600';
    const trackColor = isFailed ? 'bg-red-100' : 'bg-gray-200';
    const barWidth = isFailed ? 100 : percentage;
    const shownPercentage = isFailed ? 0 : percentage;
    const renderSublabel = () => {
        if (isFailed) {
            return React.createElement("span", { className: "text-sm text-red-700" }, errorMessage);
        }
        if (isComplete) {
            return (React.createElement("span", { className: "text-sm text-emerald-700" }, t('pitchCreation.upload.complete')));
        }
        return React.createElement("span", { className: "text-sm text-gray-500" }, etaLabel);
    };
    return (React.createElement("div", { className: "rounded-xl border border-gray-200 p-4" },
        React.createElement("div", { className: "flex items-start gap-3" },
            React.createElement("span", { className: "material-symbols-outlined mt-0.5 text-xl text-gray-700" }, "attach_file"),
            React.createElement("div", { className: "min-w-0 flex-1" },
                React.createElement("p", { className: "truncate font-semibold text-gray-900" }, fileName),
                React.createElement("p", { className: "mt-0.5" }, renderSublabel())),
            React.createElement("button", { type: "button", onClick: onRemove, "aria-label": t('pitchCreation.upload.remove'), className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200" },
                React.createElement("span", { className: "material-symbols-outlined text-xl text-gray-700" }, "close"))),
        React.createElement("div", { className: "mt-3 flex items-center gap-3" },
            React.createElement("div", { className: `h-2 flex-1 overflow-hidden rounded-full ${trackColor}` },
                React.createElement("div", { className: `h-full rounded-full transition-all ${barColor}`, style: { width: `${barWidth}%` } })),
            React.createElement("span", { className: "w-12 text-right text-sm text-gray-600" },
                shownPercentage,
                "%"))));
};
export default UploadedFileRow;
